"use strict";

var _locales = require("libs/utils/locales");
var _lodash = require("lodash");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _require = require('src/fp-i18n-utils'),
  getAllI18nKeys = _require.getAllI18nKeys;
var minimatch = require('minimatch');
var _require2 = require('src/slugify-utils'),
  reduceAccentsAndSpecialChars = _require2.reduceAccentsAndSpecialChars;
module.exports = /* @ngInject */["$window", "$log", "$route", "$routeParams", "$rootScope", "$scope", "$q", "eventService", "metadataService", "settingsService", "i18nService", "timeService", "bulkUpdateService", "registry", "settings", "i18n", "vueI18n", "modalService", function ($window, $log, $route, $routeParams, $rootScope, $scope, $q, eventService, metadataService, settingsService, i18nService, timeService, bulkUpdateService, registry, settings, i18n, vueI18n, modalService) {
  var _currentRouteDescript;
  var eventId = $routeParams.eventId;
  var event = $rootScope.event;
  $scope.eventId = eventId;
  var currentRouteDescriptor = ($route.current || {}).$$route;
  i18n = $scope.i18n = i18n.data;
  settings = $scope.settings = settings.data;
  $scope.vueI18n = vueI18n;

  // ⚑ TODO: fix name mess
  var registryNavEditors = (registry.data || {}).navs || {};
  registry = (registry.data || {}).settings || {};
  var metadata = metadataService.getCachedMetadata(eventId);

  // settings pane content init begins here

  // helper fn: entries may be arrays or objects in the blueprint. let's handle these two possible inputs
  var pluckSettingsKeyEntriesFn = settingsService.pluckSettingsKeyEntriesFromHashOrList;

  // .. settings & navs

  var settingsKeys = pluckSettingsKeyEntriesFn((currentRouteDescriptor.settings || {}).entries);
  $scope.settingsKeys = settingsKeys;
  $scope.navsKeys = pluckSettingsKeyEntriesFn((currentRouteDescriptor.nav || {}).entries);
  $scope.componentEntries = (_currentRouteDescript = currentRouteDescriptor.components) === null || _currentRouteDescript === void 0 ? void 0 : _currentRouteDescript.entries.map(function (entry) {
    return _objectSpread(_objectSpread({}, entry), {}, {
      i18nKey: "".concat(entry.label)
    });
  });

  // .. i18n

  var i18nMatchers = pluckSettingsKeyEntriesFn((currentRouteDescriptor.i18n || {}).entries || []);

  // process keys. reduce wildcards to sets of actual matched keys
  var i18nKeys = $scope.i18nKeys = [];
  i18nMatchers.forEach(function (matcher) {
    return i18nKeys.push.apply(i18nKeys, getAllI18nKeys(i18n).filter(minimatch.filter(matcher, {
      nocase: true
    })));
  });
  angular.copy(_.uniq(i18nKeys), i18nKeys);
  $scope.topLevelI18nKeys = _.uniq(i18nKeys.map(function (key) {
    var dotIdx;
    if ((dotIdx = key.indexOf('.')) === -1) {
      return key;
    }
    return key.substring(0, dotIdx);
  })).sort();

  // .. nav editors
  var navEditors = currentRouteDescriptor.navEditors;
  if (navEditors) {
    $scope.navEditors = _.chain(navEditors).map(function (descriptor, key) {
      if (!_.isObject(descriptor)) {
        return;
      }
      descriptor.key = key;
      return descriptor;
    }).compact().value();
  }

  // .. all prefs pane items (used to render prefs nav)

  var preferencesPaneItemsObj = {};
  if ((i18nKeys || {}).length) {
    preferencesPaneItemsObj.i18n = currentRouteDescriptor.i18n;
  }
  if (navEditors) {
    preferencesPaneItemsObj.navs = currentRouteDescriptor.navEditors;
  }
  if ((settingsKeys || {}).length) {
    preferencesPaneItemsObj.settings = currentRouteDescriptor.settings;
  }
  _.extend(preferencesPaneItemsObj, currentRouteDescriptor.customItems || {});
  $scope.preferencesPaneItems = _.map(preferencesPaneItemsObj, function (descriptor, key) {
    return _.extend(descriptor, {
      key: key
    });
  });

  // .. custom item docs

  var customPreferencesPaneDocs = $scope.customPreferencesPaneDocs = {};
  $scope.customItemsDescriptors = currentRouteDescriptor.customItems;
  if ($scope.customItemsDescriptors) {
    _.forEach(currentRouteDescriptor.customItems, function (descriptor, key) {
      var promises = descriptor.types.map(function (type) {
        return eventService.getEventDocsByType(event, type);
      });
      return $q.all(promises).then(function (results) {
        customPreferencesPaneDocs[key] = results.reduce(function (arr, results) {
          return arr.concat(results.data);
        }, []);
        // if nothing is selected preselect the first doc in the list we just retrieved
        if (($scope.selectedKey || {}).length || !customPreferencesPaneDocs[key].length) {
          return;
        }
        var docToSelect = _.first(customPreferencesPaneDocs[key]);
        return $scope.selectItem(docToSelect._id, 'item', docToSelect);
      });
    });
  }

  // the remaining init stuff follows

  var isUserEditingUnsavedDoc = false;

  // SEARCH

  var contains = function contains() {
    var big = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var sub = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return reduceAccentsAndSpecialChars(big).toLowerCase().indexOf(sub.toLowerCase()) > -1;
  };
  $scope.selectComponentEntry = function (componentEntry) {
    $scope.selectedComponentEntry = componentEntry;
    $scope.selectedKey = null;
  };
  $scope.isComponentEntrySelected = function (componentEntry) {
    return $scope.selectedComponentEntry === componentEntry;
  };
  $scope.filterSettingsKeys = function (itemKey) {
    var filterQueryText = $scope.filterQueryText;
    if (!(filterQueryText || {}).length) {
      return true;
    }
    if (contains(itemKey, filterQueryText)) {
      return true;
    }
    if (_.values(settings[itemKey]).some(function (val) {
      return contains(JSON.stringify(val), filterQueryText);
    })) {
      return true;
    }
    var mdFields = metadataService.convertMetadataHashToOrderedList(registry[itemKey]);
    if (_.values(mdFields).some(function (fieldDescriptor) {
      return contains(fieldDescriptor.field, filterQueryText) || contains(fieldDescriptor.label, filterQueryText);
    })) {
      return true;
    }
  };
  $scope.filterI18nKeys = function (itemKey) {
    var filterQueryText = $scope.filterQueryText;
    if (!filterQueryText) {
      return true;
    }
    // i18n keys themselves don't contain spaces (optimisation)
    if (filterQueryText.indexOf(' ') === -1) {
      if (contains(itemKey, filterQueryText)) {
        return true;
      }
    }
    // but i18n translations CAN contain spaces (so continue the search)
    var translation = (0, _lodash.get)(i18n, "".concat(itemKey, ".en"));
    return contains(translation, filterQueryText);
  };
  $scope.cachedActiveI18nToplevelKeys = {};
  $scope.filterI18nToplevelKeys = function (itemKey) {
    var filterQueryText = $scope.filterQueryText;
    if (!filterQueryText) {
      return true;
    }
    if (!$scope.cachedActiveI18nToplevelKeys[filterQueryText]) {
      $scope.cachedActiveI18nToplevelKeys = {};
      $scope.cachedActiveI18nToplevelKeys[filterQueryText] = _.uniq(i18nKeys.filter($scope.filterI18nKeys).map(function (key) {
        var dotIdx;
        if ((dotIdx = key.indexOf('.')) === -1) {
          return key;
        }
        return key.substring(0, dotIdx);
      }));
    }
    return $scope.cachedActiveI18nToplevelKeys[filterQueryText].includes(itemKey);
  };
  $scope.filterCustomDocs = function (itemDocument) {
    var filterQueryText = $scope.filterQueryText;
    if (!(filterQueryText || {}).length) {
      return true;
    }
    if (_.values(itemDocument).some(function (val) {
      return contains(JSON.stringify(val), filterQueryText);
    })) {
      return true;
    }
    var itemLabel = metadataService.getReprLabelForItem(eventId, itemDocument);
    if (contains(itemLabel, filterQueryText)) {
      return true;
    }
    var mdFields = metadataService.convertMetadataHashToOrderedList(metadata[itemDocument.fp_type]);
    if (_.values(mdFields).some(function (fieldDescriptor) {
      return contains(fieldDescriptor.field, filterQueryText) || contains(fieldDescriptor.label, filterQueryText);
    })) {
      return true;
    }
  };
  $scope.addNewDocumentOfType = function (type, itemKey) {
    var _id;
    if (!_.isArray(customPreferencesPaneDocs[itemKey])) {
      return;
    }
    var metadataForType = metadata[type];
    var defaults = metadataService.extractDefaults(metadataForType);
    var doc = _.extend({}, defaults, {
      fp_type: type,
      fp_ext_id: _id = bulkUpdateService.generateAutoGeneratedValueString(),
      _id: _id
    });
    customPreferencesPaneDocs[itemKey].unshift(doc);
    $scope.selectItem(_id, 'item', doc);
    doc._is_unsaved_prefs_item_doc = true; // flag removed on save
    return isUserEditingUnsavedDoc = true;
  };
  $scope.addTranslationKey = function () {
    modalService.openModalWithForm({
      title: 'Add a new translation key',
      fields: {
        key: {
          order: 1,
          validations: {
            custom: {
              errorMessage: 'Chosen key is either invalid, reserved, or already used.'
            }
          }
        }
      },
      formCanBeSaved: function formCanBeSaved(model, form) {
        var valid = (0, _locales.validateNewI18nKey)(model.key, i18n);
        var field = (0, _lodash.get)(form, 'genericFieldForm.key');
        if (field) {
          field.$setValidity('customValidator', valid);
        }
        return valid;
      }
    }).then(function (model) {
      (0, _lodash.set)(i18nKeys, model.key, {
        en: ''
      });
      $scope.selectItem(model.key, 'i18n');
    });
  };
  $scope.deleteDocument = function (type, doc, itemKey) {
    var event = eventService.decorateScope(eventId);
    modalService.openAlert({
      title: 'Delete template',
      message: 'Are you sure you wish to delete this template?',
      okLabel: 'Yes',
      cancelLabel: 'No'
    }).then(function () {
      bulkUpdateService.deleteDocs(eventId, event.node, type, doc.fp_ext_id);
      var list = $scope.customPreferencesPaneDocs[itemKey];
      var deleteIndex = list.map(function (template) {
        return template._id;
      }).indexOf(doc._id);
      var selectedIndex = list.map(function (template) {
        return template._id;
      }).indexOf($scope.selectedKey);
      delete list[deleteIndex];
      if (deleteIndex === selectedIndex) {
        var newIndex = selectedIndex ? selectedIndex - 1 : selectedIndex + 1;
        $scope.selectItem(list[newIndex]._id, 'item', list[newIndex]);
      }
    });
  };

  // / SEARCH

  var originalSettingsForKey = null;
  $scope.selectItem = function (itemKey) {
    var itemType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'setting';
    var itemDocument = arguments.length > 2 ? arguments[2] : undefined;
    var metadataForType;
    var modelExprToWatch;
    if (isUserEditingUnsavedDoc && !confirm('You are editing an unsaved item. Discard it?')) {
      return;
    }
    isUserEditingUnsavedDoc = false;
    $scope.selectedKey = itemKey;
    $scope.selectedItemType = itemType;
    $scope.selectedComponentEntry = null;
    if (itemType === 'nav') {
      var _config = $scope.selectedNavEditorConfig = navEditors[itemKey];
      $scope.selectedNavEditor = registryNavEditors[_config.editor];
    } else if (itemType === 'setting' || itemType === 'item') {
      var formMetadata = _.map(metadataForType = registry[itemKey] || metadata[itemDocument.fp_type], function (item, key) {
        return _.extend({}, item, {
          field: key
        });
      });
      if (itemType === 'item') {
        formMetadata = formMetadata.filter(function (m) {
          return m.field.indexOf('_') !== 0;
        });
      }

      // only let one targets or exceptions filter through because the single widget caters for both
      $scope.formMetadata = metadataService.filterDuplicateTargetsExceptionsFields(formMetadata);

      // pull the defaults out of the registry and into our local settings doc
      // NOTE: we must clone each property value so that we are not modifying the registry's copy
      var defaults = metadataForType ? metadataService.extractDefaults(metadataForType) : {};
      if (itemType === 'setting') {
        settings[itemKey] = $scope.formModel = _.extend({}, defaults, settings[itemKey] || (settings[itemKey] = {}));
        // ⚑
        // TODO: hack because timestamps are no longer converted to strings by the api (regression)
        timeService.convertTimestampsToHumanFormInObject(settings[itemKey], formMetadata, event.timezone);

        // we keep a reference to this so that we can compute our changes later on
        // unfortunately must be a DEEP CLONE because we don't want to change inner nested-objects and lists via the form !
        originalSettingsForKey = JSON.parse(JSON.stringify(settings[itemKey]));
      } else {
        $scope.formModel = itemDocument;
      }
      modelExprToWatch = 'formModel';
    } else if (itemType === 'i18n') {
      var selectedI18nValue = $scope.selectedI18nValue = (0, _lodash.get)(i18n, itemKey, {});
      $scope.selectedI18nMetadata = i18nService.getMetadataForI18nEditor(selectedI18nValue);
      modelExprToWatch = 'selectedI18nValue';
    } else {
      return;
    }

    // watch selected item doc for changes
    $scope.$watch(modelExprToWatch, function (newValue, oldValue) {
      if (!oldValue || angular.equals(newValue, oldValue)) {
        return;
      }
      return $scope.setNavigationWarningMessage('You may have made changes. Discard them?');
    }, true);
    // delete any custom item docs that are unsaved (those that have _is_unsaved_prefs_items_doc set)
    _.values(customPreferencesPaneDocs).forEach(function (list) {
      // it'll only ever be the first doc that has this flag set
      // (because we unshift the new doc and there is only ever one)
      if ((list || {}).length && (list[0] || {})._is_unsaved_prefs_item_doc) {
        return list.shift();
      }
    });
    // a very grubby scroll-to-top hack
    angular.element($window).scrollTop(0);
  };
  $scope.saveSettingsOrItem = function (itemKey, itemType, itemDocument) {
    var successCb = function successCb() {
      $scope.setFlashMessage('The settings have been saved.');
      $scope.setNavigationWarningMessage(null);
      return $route.reload();
    };
    var errCb = function errCb(err) {
      alert('There was a problem saving the settings item.');
      $log.error('settings save error!', err);
      return $scope.saveInProgress = false;
    };
    $scope.saveInProgress = true;
    if (itemType === 'item') {
      if (!itemDocument) {
        return;
      }
      var funcName = itemDocument._is_unsaved_prefs_item_doc ? 'createDocs' : 'updateDoc';
      delete itemDocument._is_unsaved_prefs_item_doc;
      return bulkUpdateService[funcName](eventId, event.node, itemDocument.fp_type, itemDocument).then(successCb, errCb);
    } else {
      // settings!
      return settingsService.saveLocalSettingsAsOverrides(event, settings, itemKey, originalSettingsForKey, registry).then(successCb, errCb);
    }
  };
  $scope.saveI18n = function (selectedI18nKey, i18nValue) {
    var errCb = function errCb(err) {
      alert('There was a problem updating the i18n dictionary.');
      $log.error('i18n save error!', err);
      return $scope.saveInProgress = false;
    };
    $scope.saveInProgress = true;
    return i18nService.updateOverrideNavBitWithSingleEdit(event, selectedI18nKey, i18nValue).then(function () {
      $scope.setFlashMessage('The translations have been updated.');
      $scope.setNavigationWarningMessage(null);
      return $scope.saveInProgress = false;
    }, errCb);
  };
  $scope.onNavBitsSavedCallback = function (bits) {
    var savedNavIds = _.pluck(bits, 'fp_subtype');
    var savedNavIdsStr = savedNavIds.toString().replace(/,/g, ', ');
    $scope.setFlashMessage("The following navs were saved: ".concat(savedNavIdsStr));
    $scope.setNavigationWarningMessage(null);
    return $scope.saveInProgress = false;
  };
  $scope.showAddI18nLanguageToMetadataPrompt = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(i18nFields) {
      var langs, langCode;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            langs = i18nFields.map(function (l) {
              return l.field;
            });
            _context.next = 3;
            return modalService.openModal({
              templateUrl: '/static/partials/components/modal-language-picker.html',
              scope: {
                lang: '',
                langs: langs
              }
            });
          case 3:
            langCode = _context.sent;
            if (langCode.length) {
              _context.next = 6;
              break;
            }
            return _context.abrupt("return");
          case 6:
            i18nFields.push({
              field: langCode,
              label: langCode.toUpperCase()
            });
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
  $scope.getLabelForModel = function (model) {
    var m = model;
    var l = metadataService.getReprLabelForItem(eventId, m);
    return l || m.name || m.title || m.subject || m.fp_ext_id || m._id || '(unsaved)';
  };
  $scope.getNameForKey = function (key) {
    return key === 'person' ? 'user' : key;
  };

  // select the first available setting OR i18n on load
  if ((settingsKeys || {}).length) {
    return $scope.selectItem(_.first(settingsKeys), 'setting');
  } else if ((i18nKeys || {}).length) {
    return $scope.selectItem(_.first(i18nKeys), 'i18n');
  }
}];